import React from 'react';
import { Button } from 'antd';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../../states/theme.atom';

interface ToggleThemeProps {
  showText?: boolean;
}

/**
 * A component that allows toggling between light and dark theme
 */
const ToggleTheme: React.FC<ToggleThemeProps> = ({ showText = false }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      type="text"
      icon={theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
      onClick={toggleTheme}
    >
      {showText ? 'Toggle theme' : ''}
    </Button>
  );
};

export default ToggleTheme;
